import { render, staticRenderFns } from "./ActivationDeliverableContentApprovalRouterView.vue?vue&type=template&id=5454c495&"
import script from "./ActivationDeliverableContentApprovalRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationDeliverableContentApprovalRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports